import { get } from 'lodash';
import safeJsonParse from '@td/emr/src/utils/json/safeJsonParse';
import getClientInstance from '../../../app/config/apollo-client';
import FETCH_DATA_FOR_RECENT_CONSULTATIONS_TABLE from './queries/fetch-data-for-recent-consultations-table-query.js';

const fetchDataForRecentConsultationsTable = (memberId)  => {
  const apolloClient = getClientInstance();

  const promise = 
    apolloClient.query({
      variables: { memberId: memberId },
      query: FETCH_DATA_FOR_RECENT_CONSULTATIONS_TABLE
    })
    .then(response => {
      const data = get(safeJsonParse(get(response, 'data.member.internalReferralRecentConsultations')), 'data.recent_consultations');

      return data;
    })

  return promise;
};

export default fetchDataForRecentConsultationsTable;
